class AllFiltersCompare extends AllFilters {
    constructor(page, elementIdPrefix, comparisonGroup) {
        super(page, elementIdPrefix);
        this.comparisonGroup = comparisonGroup;
    }

    saveFiltersState(filtersForSearch) {
        let storedFiltersCode;

        storedFiltersCode = coreFunctions.getRandomString(15);

        // Limit to size of local storage variables
        if (!filtersForSearch.filters.CompanyNumbers || filtersForSearch.filters.CompanyNumbers.length < 100000) {
            filtersForSearch.code = storedFiltersCode;
            this.storedFiltersCode = storedFiltersCode;
            if (filtersForSearch.rticCompanies) {
                filtersForSearch.rtics = this.rticFilters.calculateActiveRtics();
            }
            // Store active filters
            localStorage.setItem(`${this.comparisonGroup}Filters`, JSON.stringify(filtersForSearch));
        }

        return this;
    }

    updateExploreLink() {
        document.querySelector(`.insightsActionsControlHolder[data-compare_element="${this.comparisonGroup}"]`).classList.remove("controlsDisabled");
        document.getElementById(`${this.comparisonGroup}ListLink`).href = `${urlPath}/explore?filters_code=${this.storedFiltersCode}`;
        return this;
    }

    copyComparisonGroupFiltersToStoredFilters() {
        localStorage.setItem("filters", localStorage.getItem(`${this.comparisonGroup}Filters`));
        return this;
    }
}